import request from '@/utils/request3'
import store from '@/store'

const serviceName = store.state.serviceName.wflow

// 我的待办
export function todo(data) {
  return request({ url: serviceName + `/wflow/task/todo`, method: 'post', data })
}

// 我的已办
export function done(data) {
  return request({ url: serviceName + `/wflow/task/done`, method: 'post', data })
}

// 抄送我的
export function ccMe(data) {
  return request({ url: serviceName + `/wflow/task/ccMe`, method: 'post', data })
}

// 我的申请
export function myApply(data) {
  return request({ url: serviceName + `/wflow/task/myApply`, method: 'post', data })
}

// 角标计数(待办数/未读抄送数)
export function counts() {
  return request({ url: serviceName + `/wflow/task/counts`, method: 'get' })
}
